import React, { useEffect, useState, useCallback, useMemo } from "react";
import { Container, Row, Col } from "react-bootstrap";

import ButtonRB from "react-bootstrap/Button"; // Aliased to avoid conflict if any, though not strictly needed here
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";

import { SiTerraform, SiGraphql, SiTrpc } from "react-icons/si";
import { BiCode, BiCodeCurly } from "react-icons/bi";

import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";

import {
  Drawer,
  IconButton,
  Tooltip,
  Typography,
  Card,
  Button as TButton, // Aliased from Material Tailwind
} from "@material-tailwind/react";

import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";

import { useLoadingStore } from "../../lib/stores/stores";
// import { toast } from "react-toastify"; // REMOVED
// import "react-toastify/dist/ReactToastify.css"; // REMOVED
import { useToast } from "@/components/hooks/use-toast"; // ADDED for shadcn toast

import Result from "./Result";
import axios from "axios";
import symbolsJson from "./symbols.json";
import dwml_title from "../../Assets/Projects/DelosTitle.png";

import {
  Client,
  cacheExchange,
  fetchExchange,
  gql,
  createRequest,
} from "urql";

// Import your new SVG Icon components
import FlaskIcon from "@/components/icons/FlaskIcon";
import DjangoIcon from "@/components/icons/DjangoIcon";
import FastApiIcon from "@/components/icons/FastApiIcon";
import ExpressIcon from "@/components/icons/ExpressIcon";
import NextJsIcon from "@/components/icons/NextJsIcon";
import SvelteKitIcon from "@/components/icons/SvelteKitIcon";
import PythonIcon from "@/components/icons/PythonIcon";
import NodeJsIcon from "@/components/icons/NodeJsIcon";

// --- Constants defined outside component ---
// REMOVED TOAST_OPTIONS
// const TOAST_OPTIONS = {
//   position: "top-center",
//   autoClose: 5000,
//   hideProgressBar: false,
//   closeOnClick: true,
//   pauseOnHover: false,
//   draggable: true,
//   progress: undefined,
//   theme: "light",
// };

// ADDED shadcn toast duration
const SHADCN_TOAST_DURATION = 3000;


// GraphQL Clients
const flaskClient = new Client({
  url: "https://master-dwml-backend-flask-lqfbwlkw2a-uc.a.run.app/graphql",
  exchanges: [cacheExchange, fetchExchange],
});
const djangoClient = new Client({
  url: "https://master-dwml-backend-django-lqfbwlkw2a-uc.a.run.app/graphql/",
  exchanges: [cacheExchange, fetchExchange],
});
const fastapiClient = new Client({
  url: "https://master-dwml-backend-fastapi-lqfbwlkw2a-uc.a.run.app/graphql",
  exchanges: [cacheExchange, fetchExchange],
});

const processRequestQuery = gql`
  query ($investment: Int!, $symbol: String!) {
    processRequest(investment: $investment, symbol: $symbol) {
      graphData
      message
    }
  }
`;

const API_CONFIGS = {
  Flask: {
    restUrl: "https://master-dwml-backend-flask-lqfbwlkw2a-uc.a.run.app/api/v1/project/core/process_request",
    graphqlClient: flaskClient,
    grpcGatewayUrl: "https://master-dwml-backend-flask-lqfbwlkw2a-uc.a.run.app/api/v1/project/core/process_request_grpc",
    headers: { "x-api-key": "436236939443955C11494D448451F" },
    responsePath: { message: 'message', graphData: 'graph_data' },
    parseMessageAsString: true,
    parseGraphDataAsString: false, // Typically graph_data is already an object
  },
  FastAPI: {
    restUrl: "https://master-dwml-backend-fastapi-lqfbwlkw2a-uc.a.run.app/process_request",
    graphqlClient: fastapiClient,
    headers: { "x-api-key": "436236939443955C11494D448451F" },
    responsePath: { message: 'message', graphData: 'graph_data' },
    parseMessageAsString: true,
    parseGraphDataAsString: false,
  },
  Django: {
    restUrl: "https://master-dwml-backend-django-lqfbwlkw2a-uc.a.run.app/api/v1/process_request/",
    graphqlClient: djangoClient,
    headers: {}, // Django REST in original code didn't use x-api-key
    responsePath: { message: 'message', graphData: 'graph_data' },
    parseMessageAsString: true,
    parseGraphDataAsString: false,
  },
  Express: {
    restUrl: "https://master-dwml-backend-express-lqfbwlkw2a-uc.a.run.app/process_request",
    headers: { "x-api-key": "436236939443955C11494D448451F" },
    responsePath: { message: 'result', graphData: 'graph_data' },
    parseMessageAsString: false,
    parseGraphDataAsString: false,
  },
  Next: {
    restUrl: "https://master-dwml-backend-next-lqfbwlkw2a-uc.a.run.app/api/process_request",
    headers: { "Content-Type": "application/json" }, // Next.js API routes often expect JSON
    responsePath: { message: 'result', graphData: 'graph_data' },
    parseMessageAsString: false,
    parseGraphDataAsString: false,
  },
  SK: { // SvelteKit
    restUrl: "https://master-dwml-backend-sveltekit-lqfbwlkw2a-uc.a.run.app/api/process_request",
    headers: { "x-api-key": "436236939443955C11494D448451F" },
    responsePath: { message: 'result', graphData: 'graph_data' },
    parseMessageAsString: false,
    parseGraphDataAsString: false,
  },
  Python: { // For gRPC via Flask Gateway
    headers: { "x-api-key": "436236939443955C11494D448451F" },
    responsePath: { message: 'message', graphData: 'graph_data' },
    parseMessageAsString: true,
    parseGraphDataAsString: true, // gRPC gateway returns graph_data as string
  },
  Node: { // Placeholder for Node gRPC
    // Not directly callable from frontend in this setup
  }
};

const GITHUB_REPOS = {
  Flask: "https://github.com/EdwinKassier/dwml-backend-flask",
  FastAPI: "https://github.com/EdwinKassier/dwml-backend-fastapi",
  Express: "https://github.com/EdwinKassier/dwml-backend-express",
  Next: "https://github.com/EdwinKassier/dwml-backend-next",
  SK: "https://github.com/EdwinKassier/dwml-backend-sveltekit",
  Python: "https://github.com/EdwinKassier/dwml-backend-python-grpc",
  Django: "https://github.com/EdwinKassier/dwml-backend-django",
  Node: "https://github.com/EdwinKassier/dwml-backend-nodejs-grpc",
};

const API_ICONS_CONFIG = {
  REST: [
    { key: "Flask", Icon: FlaskIcon, defaultColor: "black" },
    { key: "Django", Icon: DjangoIcon, defaultColor: "#092E20" },
    { key: "FastAPI", Icon: FastApiIcon, defaultColor: "#009688" },
    { key: "Express", Icon: ExpressIcon, defaultColor: "#3c873a" },
    { key: "Next", Icon: NextJsIcon, defaultColor: "black" },
    { key: "SK", Icon: SvelteKitIcon, defaultColor: "#FF3E00", isConditionalColor: true },
  ],
  GraphQL: [
    { key: "Flask", Icon: FlaskIcon, defaultColor: "black" },
    { key: "Django", Icon: DjangoIcon, defaultColor: "#092E20" },
    { key: "FastAPI", Icon: FastApiIcon, defaultColor: "#009688" },
  ],
  Grpc: [
    { key: "Python", Icon: PythonIcon, defaultColor: "#3776ab", isConditionalColor: true },
    { key: "Node", Icon: NodeJsIcon, defaultColor: "#6cc24a", isConditionalColor: true },
  ],
};
// --- End Constants ---

function DWML() {
  const { toast } = useToast(); // ADDED useToast hook
  const [radioValue, setRadioValue] = useState("Flask");
  const [symbolValue, setSymbolValue] = useState([]); // For Typeahead selected values
  const [investmentValue, setInvestmentValue] = useState("");

  const [shallowSubmittedValues, setShallowSubmittedValues] = useState({
    symbol: [],
    investment: "",
  });
  const [queryResult, setQueryResult] = useState(null);
  const [graphDataResult, setGraphDataResult] = useState(null);
  const isLoading = useLoadingStore((state) => state.loading);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const [protocolAlignment, setProtocolAlignment] = useState("REST");

  useEffect(() => {
    if (queryResult) {
      setIsDrawerOpen(true);
    }
  }, [queryResult]);

  const handleProtocolChange = useCallback((event, newAlignment) => {
    if (newAlignment !== null && newAlignment !== protocolAlignment) {
      setProtocolAlignment(newAlignment);
      const supportedApis = API_ICONS_CONFIG[newAlignment]?.map(api => api.key) || [];
      if (!supportedApis.includes(radioValue)) {
        setRadioValue(supportedApis[0] || "Flask");
      }
    }
  }, [protocolAlignment, radioValue]);

  const handleCloseDrawer = useCallback(() => {
    setIsDrawerOpen(false);
  }, []);

  const handleInvestmentChange = useCallback((event) => {
    setInvestmentValue(event.target.value.replace(/\D/g, ""));
  }, []);

  const handleSymbolChange = useCallback((selected) => {
    setSymbolValue(selected);
  }, []);

  const handleAPIChange = useCallback((api) => {
    setRadioValue(api);
    window.analytics?.track("Change target API", { target: api });
  }, []);

  const openInNewTab = useCallback((url) => {
    window.analytics?.track("Link opened", { target: url });
    window.open(url, "_blank", "noopener,noreferrer");
  }, []);

  const openApiSource = useCallback(() => {
    const url = GITHUB_REPOS[radioValue] || GITHUB_REPOS["Django"];
    openInNewTab(url);
  }, [radioValue, openInNewTab]);

  const openTerraformSource = useCallback(() => {
    openInNewTab("https://github.com/EdwinKassier/Ashes-Devops-Tools");
  }, [openInNewTab]);

  const executeQuery = useCallback(async (apiType, protocol) => {
    const currentApiConfig = API_CONFIGS[apiType];

    if (!currentApiConfig) {
      toast({
        title: "Configuration Error",
        description: `Configuration for API type ${apiType} not found.`,
        variant: "destructive",
        duration: SHADCN_TOAST_DURATION,
      });
      throw new Error("ConfigurationError");
    }
    
    if (
        investmentValue === "" ||
        !(parseFloat(investmentValue) > 0) ||
        !symbolValue || symbolValue.length === 0
      ) {
        toast({
            title: "Input Required",
            description: "Please input a valid symbol and investment amount.",
            duration: SHADCN_TOAST_DURATION,
        });
        throw new Error("ValidationError");
      }

    const params = {
      symbol: symbolValue[0],
      investment: investmentValue,
    };

    try {
      let responseData;
      let finalQueryData;
      let finalGraphData;

      if (protocol === "REST" || (protocol === "Grpc" && apiType === "Python")) {
        const url = (protocol === "Grpc" && apiType === "Python")
            ? API_CONFIGS.Flask.grpcGatewayUrl
            : currentApiConfig.restUrl;

        if (!url) {
          toast({
            title: "Configuration Error",
            description: `Endpoint URL for ${apiType} (${protocol}) not configured.`,
            variant: "destructive",
            duration: SHADCN_TOAST_DURATION,
          });
          throw new Error(`Endpoint URL for ${apiType} (${protocol}) not configured.`);
        }
        
        const headers = (protocol === "Grpc" && apiType === "Python") 
            ? API_CONFIGS.Python.headers 
            : currentApiConfig.headers;

        const axiosConfig = { headers, params };
        const res = await axios.get(url, axiosConfig);
        responseData = res.data;

        const rawMessage = responseData[currentApiConfig.responsePath.message];
        const rawGraphData = responseData[currentApiConfig.responsePath.graphData];

        if (rawMessage === "Symbol doesn't exist" || rawGraphData === "Symbol doesn't exist") {
            throw new Error("Symbol doesn't exist");
        }
        
        finalQueryData = currentApiConfig.parseMessageAsString && typeof rawMessage === 'string'
            ? JSON.parse(rawMessage)
            : rawMessage;
        
        finalGraphData = currentApiConfig.parseGraphDataAsString && typeof rawGraphData === 'string'
            ? JSON.parse(rawGraphData)
            : rawGraphData;

      } else if (protocol === "GraphQL") {
        if (!currentApiConfig.graphqlClient) {
          toast({
            title: "Configuration Error",
            description: `GraphQL client for ${apiType} not configured.`,
            variant: "destructive",
            duration: SHADCN_TOAST_DURATION,
          });
          throw new Error(`GraphQL client for ${apiType} not configured.`);
        }
        const request = createRequest(processRequestQuery, {
          investment: parseInt(investmentValue),
          symbol: symbolValue[0],
        });
        const res = await currentApiConfig.graphqlClient.executeQuery(request).toPromise();

        if (res.error) {
          console.error("GraphQL Error:", res.error);
          const gqlErrorMessage = res.error.graphQLErrors?.[0]?.message || res.error.message;
          if (gqlErrorMessage?.toLowerCase().includes("symbol doesn't exist")) {
            throw new Error("Symbol doesn't exist");
          }
          throw new Error(gqlErrorMessage || "GraphQL error processing request.");
        }
        if (!res.data || !res.data.processRequest) {
          throw new Error("Invalid GraphQL response structure.");
        }
        
        const gqlProcResponse = res.data.processRequest;
        if (gqlProcResponse.message === "Symbol doesn't exist") {
            throw new Error("Symbol doesn't exist");
        }
        try {
            finalQueryData = JSON.parse(gqlProcResponse.message);
        } catch (e) {
            console.error("GraphQL: Failed to parse message JSON", e, gqlProcResponse.message);
            throw new Error("GraphQL: Invalid message format from server.");
        }
        finalGraphData = gqlProcResponse.graphData;

      } else {
        toast({
            title: "Unsupported Operation",
            description: `Protocol ${protocol} for ${apiType} is not supported or fully implemented.`,
            duration: SHADCN_TOAST_DURATION,
        });
        throw new Error(`Protocol ${protocol} for ${apiType} is not supported.`);
      }

      if (finalQueryData === null || finalQueryData === false) {
        throw new Error("Invalid data received from server (null/false message).");
      }

      setQueryResult(finalQueryData);
      setGraphDataResult(finalGraphData);
      setShallowSubmittedValues({ symbol: symbolValue, investment: investmentValue });

    } catch (err) {
      console.error(`Error querying ${apiType} via ${protocol}:`, err);
      let toastMessage = "Error fetching data or symbol doesn't exist.";
      let toastTitle = "Request Failed";
      let toastVariant = "destructive";

      if (err.message?.toLowerCase().includes("symbol doesn't exist")) {
        toastMessage = `That symbol doesn't exist on our target exchange.`;
        setSymbolValue([]);
      } else if (err.message?.includes("GraphQL")) {
        toastMessage = err.message;
        toastTitle = "GraphQL Error";
      } else if (err.message?.includes("Invalid message format")) {
        toastMessage = `Received an invalid message format from the server.`;
        toastTitle = "Data Error";
      } else if (err.message === "ValidationError" || err.message === "ConfigurationError") {
        // These are handled by prior toasts
      }
      
      if (err.message !== "ValidationError" && err.message !== "ConfigurationError") {
         toast({
            title: toastTitle,
            description: toastMessage,
            variant: toastVariant,
            duration: SHADCN_TOAST_DURATION,
         });
      }

      setQueryResult(null);
      setGraphDataResult(null);
      throw err;
    }
  }, [symbolValue, investmentValue, toast]);

  const handleApiSubmit = useCallback(async () => {
    if (queryResult) {
      setIsDrawerOpen(false);
      setQueryResult(null);
      setGraphDataResult(null);
    }
    useLoadingStore.setState({ loading: true });

    let effectiveApiType = radioValue;
    let effectiveProtocol = protocolAlignment;

    try {
      if (effectiveProtocol === "Grpc") {
        if (effectiveApiType === "Python") {
          // Handled by executeQuery
        } else if (effectiveApiType === "Node") {
          toast({
            title: "Not Implemented",
            description: "Direct Node.js gRPC from client is not implemented. Select Python for gRPC via HTTP Gateway.",
            duration: SHADCN_TOAST_DURATION,
          });
          throw new Error("UnsupportedOperation");
        } else {
          toast({
            title: "Unsupported Operation",
            description: `gRPC for ${effectiveApiType} is not supported through this interface.`,
            duration: SHADCN_TOAST_DURATION,
          });
          throw new Error("UnsupportedOperation");
        }
      } else if (effectiveProtocol === "GraphQL") {
        if (!API_CONFIGS[effectiveApiType]?.graphqlClient) {
          toast({
            title: "Unsupported Operation",
            description: `${effectiveApiType} does not support GraphQL with this setup. Please select Flask, Django, or FastAPI.`,
            duration: SHADCN_TOAST_DURATION,
          });
          throw new Error("UnsupportedOperation");
        }
      }
      await executeQuery(effectiveApiType, effectiveProtocol);
    } catch (error) {
      console.info("Submission process encountered an issue:", error.message);
    } finally {
      useLoadingStore.setState({ loading: false });
    }
  }, [radioValue, protocolAlignment, executeQuery, queryResult, toast]);

  const displayedApiIcons = useMemo(() => API_ICONS_CONFIG[protocolAlignment] || [], [protocolAlignment]);

  return (
    <Container fluid className="project-section">
      {/* Ensure <Toaster /> from shadcn/ui is rendered in your root layout or a parent component */}
      <div className="py-4" />
      <Container style={{ animation: `fadeIn 2s` }}>
        <Tooltip
          placement="bottom"
          className="border border-blue-gray-50 bg-white px-4 py-3 shadow-xl shadow-black/10"
          open={isTooltipOpen}
          handler={setIsTooltipOpen}
          content={
            <div className="w-80">
              <Typography variant="small" color="blue-gray" className="font-normal opacity-80">
                Ever wondered if you could have bought a <span style={{ color: "#DA8C0B" }}>Lamborghini</span> if you had just invested in that one crypto currency when it was first released?
              </Typography>
              <br />
              <Typography variant="small" color="blue-gray" className="font-normal opacity-80">
                Imagine you bought a crypto currency in the first week it launched on an exchange and sold at the average price of the last month, would you have been able to buy a lamborghini? Project Delos seeks to answer that question
              </Typography>
              <br />
              <Typography variant="small" color="blue-gray" className="font-normal opacity-80">
                The backend for this application has been replicated across six separate web frameworks: Flask, Django, FastAPI, Express, Next and Sveltekit. All APIs are currently running in managed K8 clusters on GCP as per my design documents for the project
              </Typography>
            </div>
          }
        >
          <span style={{ fontSize: "1.5rem", cursor: "pointer" }} onClick={() => { setIsTooltipOpen(!isTooltipOpen); window.analytics?.track(`Delos tooltip ${!isTooltipOpen ? 'open' : 'close'}`); }}>
            <div className="image-container">
              <img src={dwml_title} width="400" height="100" alt="Project Delos Title" />
            </div>
          </span>
        </Tooltip>

        <div className=" columns-2 gap-2 space-x-4 flex justify-center pt-12">
          <div className="flex items-center justify-center space-x-4">
            <button className=" dwml-repo-button flex items-center justify-center w-auto p-3  rounded-full " onClick={openApiSource}>
              <BiCode size={"1.1em"} />
            </button>
            <div>API source</div>
          </div>
          <div className="flex items-center justify-center space-x-4">
            <button className=" dwml-repo-button flex items-center justify-center  w-auto p-3  rounded-full " onClick={openTerraformSource}>
              <SiTerraform size={"1.1em"} />
            </button>
            <div>Terraform source</div>
          </div>
        </div>

        <br />
        <Card className="w-full p-8 justify-center shadow-none">
          <div className="inline-flex items-center justify-center w-full">
            <hr className="tablet:w-1/2 phone:w-full h-px my-8 bg-gray-200 border-0 dark:bg-gray-700" />
            <span className="absolute px-3 font-medium text-black -translate-x-1/2 bg-white left-1/2 dark:text-white dark:bg-gray-900">
              <Typography variant="lead" color="blue-gray">Target Protocol</Typography>
            </span>
          </div>

          <ToggleButtonGroup
            value={protocolAlignment}
            exclusive
            onChange={handleProtocolChange}
            aria-label="Select Protocol"
            color={protocolAlignment === "GraphQL" ? "secondary" : protocolAlignment === "REST" ? "primary" : "success"}
            className="divide-x-2 gap-4 py-2 justify-center flex-wrap"
          >
            <ToggleButton style={{ borderRadius: "30px", outline: "0.5px solid" }} className=" hover:text-[#4285F4] focus:text-blue-500" value="REST">
              <BiCodeCurly size={"1.8em"} className="pr-2" /> REST
            </ToggleButton>
            <ToggleButton style={{ borderRadius: "30px", outline: "0.5px solid" }} className=" hover:text-[#e535ab] active:text-blue-500" value="GraphQL">
              <SiGraphql size={"1.8em"} className="pr-2" /> GraphQL
            </ToggleButton>
            <ToggleButton style={{ borderRadius: "30px", outline: "0.5px solid" }} className=" hover:text-[#4caf50] active:text-blue-500" value="Grpc">
              <SiTrpc size={"1.8em"} className="pr-2" /> Grpc
            </ToggleButton>
          </ToggleButtonGroup>

          <Row style={{ justifyContent: "center" }} className="space-y-4 flex-row">
            <div className="inline-flex items-center justify-center w-full">
              <hr className="tablet:w-1/2 phone:w-full h-px my-8 bg-gray-200 border-0 dark:bg-gray-700" />
              <span className="absolute px-3 font-medium text-black -translate-x-1/2 bg-white left-1/2 dark:text-white dark:bg-gray-900">
                <Typography variant="lead" color="blue-gray">Target API</Typography>
              </span>
            </div>
            
            {displayedApiIcons.length > 0 && (
              <div className="flex flex-row desktop:justify-center tablet:justify-center phone:m-auto gap-14 overflow-x-auto no-scrollbar py-4">
                {displayedApiIcons.map(({ key, Icon, defaultColor, isConditionalColor }) => (
                  <div
                    key={key}
                    style={{ justifyContent: "center", alignContent: "center" }}
                    className="project-card"
                  >
                    <div
                      className="image-container cursor-pointer"
                      onClick={() => handleAPIChange(key)}
                      title={`Select ${key} API`}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) => e.key === 'Enter' && handleAPIChange(key)}
                    >
                      <Icon
                        {...(isConditionalColor
                          ? { conditionalFillColor: radioValue === key ? "#DA8C0B" : defaultColor }
                          : { fillColor: radioValue === key ? "#DA8C0B" : defaultColor })}
                      />
                    </div>
                  </div>
                ))}
              </div>
            )}

            <Col md={6} className="project-card">
              <h5>Crypto Symbol</h5>
              <br />
              <InputGroup className="mb-3">
                <Typeahead
                  id="symbol-typeahead"
                  labelKey="name"
                  onChange={handleSymbolChange}
                  options={symbolsJson.symbols}
                  placeholder="Choose a crypto Symbol..."
                  selected={symbolValue}
                  clearButton
                />
              </InputGroup>
            </Col>

            <Col md={6} className="project-card">
              <h5>Initial Investment</h5>
              <br />
              <InputGroup className="mb-3">
                <InputGroup.Text>$</InputGroup.Text>
                <Form.Control
                  value={investmentValue}
                  onChange={handleInvestmentChange}
                  aria-label="Amount (to the nearest dollar)"
                  type="text" 
                  inputMode="numeric"
                  pattern="[0-9]*"
                />
              </InputGroup>
            </Col>

            <TButton
              disabled={isLoading}
              onClick={handleApiSubmit}
              variant="text"
              className="flex items-center gap-2 justify-center w-1/2 mx-auto"
            >
              {isLoading ? "Submitting..." : "Submit"}
            </TButton>
            <div className="py-2" />
          </Row>
        </Card>

        <div className="py-4" />

        {queryResult && (
          <Drawer open={isDrawerOpen} onClose={handleCloseDrawer} size={450} overlay={false} placement={"right"} className="p-4 overflow-y-scroll no-scrollbar shadow-2xl">
            <div className="absolute top-5 right-5">
              <IconButton variant="text" color="blue-gray" onClick={handleCloseDrawer}>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="h-5 w-5">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </IconButton>
            </div>
            <div className="text-center">
              <Result
                coinSymbol={shallowSubmittedValues.symbol}
                initialCoins={typeof queryResult["NUMBERCOINS"] === 'number' ? queryResult["NUMBERCOINS"].toFixed(5) : "N/A"}
                NetProfit={queryResult["PROFIT"]}
                GrowthFactor={queryResult["GROWTHFACTOR"]}
                InitialInvestment={shallowSubmittedValues.investment}
                NumberLambos={queryResult["LAMBOS"]}
                GraphData={graphDataResult}
              />
            </div>
          </Drawer>
        )}
      </Container>
    </Container>
  );
}

export default DWML;